export default () => jQuery(($) => {
    /* Desktop behavior */
    var close = function(toggler){
        var wrapper = $(".home-page-banner__more-nav-wrapper");
        wrapper.addClass("home-page-banner__more-nav-wrapper--closing");
        toggler.removeClass("home-page-banner__more-toggle--open");
        window.setTimeout(function(){
            wrapper.children().appendTo(wrapper.parent());
            wrapper.remove();
        }, 500 );
    };
    var open = function(toggler){
        var wrapper = $("<div class=\"home-page-banner__more-nav-wrapper home-page-banner__more-nav-wrapper--initial\" />");
        var more_blocks = $(".home-page-banner__more-nav-items");
        more_blocks.wrapAll(wrapper);
        more_blocks.find("a, button, :input, [tabindex]").blur(function(){
            window.setTimeout(function(){
                if($(':focus').closest(".home-page-banner__more-nav-wrapper").length < 1) {
                    close(toggler);
                }
            }, 10 );
        });
        toggler.addClass("home-page-banner__more-toggle--open");
        window.setTimeout(function(){
            $(".home-page-banner__more-nav-wrapper--initial").removeClass("home-page-banner__more-nav-wrapper--initial");
        }, 30 );
    };
    $(".home-page-banner__more-toggle").click(function(){
        var toggler = $(this);
        if(toggler.hasClass("home-page-banner__more-toggle--open")) {
            close(toggler);
        } else {
            open(toggler);
        }
    });

    /* Mobile behavior */
    var tabsWrapper = $(".home-page-banner__nav-tabs");
    var allTabs = $(".home-page-banner__nav-tab");
    var allTabContents = $(".home-page-banner__tab-content");
    function updateTabContent(tab) {
        var thisContent = $('#' + tab.attr('aria-controls'));
        var currentlySelected = ("true" == tab.attr('aria-selected')) ? true : false;
        allTabs.attr('aria-selected', 'false');
        allTabContents.addClass('home-page-banner__tab-content--fully-hidden');
        if(!currentlySelected){
            console.log('enabled ' + tab.attr('id'));
            tab.attr('aria-selected', 'true');
            thisContent.removeClass('home-page-banner__tab-content--fully-hidden');
        }
    }
    allTabContents.addClass('home-page-banner__tab-content--fully-hidden');
    allTabs.click(function(){
        updateTabContent($(this));
    });
    /* Todo: figure out how to make this work properly across the breakpoint */
    function conditionalAriaSetup(){
        if(tabsWrapper.css('display') !== "none") {
            allTabContents.attr("role", "tabpanel");
            allTabs.each(function(){
                if($(this).attr("aria-controls") && $(this).attr("id") && $("#" + $(this).attr("aria-controls")).length) {
                    $("#" + $(this).attr("aria-controls")).attr("aria-labelledby", $(this).attr("id"));
                }
            });
        } else {
            allTabContents.removeAttr("role").removeAttr("aria-labelledby");
        }
    }
    $(window).resize(function(){
        conditionalAriaSetup();
    });
    conditionalAriaSetup();

    var banner = $(".home-page-banner");
    $(window).scroll(function(){
        if($(document).scrollTop() > $(window).height()) {
            banner.addClass("home-page-banner--fixed");
        } else {
            banner.removeClass("home-page-banner--fixed");
        }
    });
});
